module.exports = __webpack_public_path__ + "static/media/Clock.9c15164f.gif";